import React from 'react';

import { Controller, Control } from 'react-hook-form';

import { TimePicker, TimeIntervals } from 'design-system-web';
import type { TimeOption } from 'design-system-web/components/DatePicker/helpers';

type Props = {
  control: Control<any>;
  name: string;
  testId?: string;
  label?: string;
  className?: string;
  buttonClassName?: string;
  style?: React.CSSProperties;
  hideLabel?: boolean;
  showClear?: boolean;
  showIcon?: boolean;
  error?: string[];
  disabled?: boolean;
  fixedLabel?: boolean;
  showTimezone?: boolean;
  timeZone?: string | null;
  unit?: TimeIntervals;
  times?: TimeOption[];
  isRequired?: boolean;
};

export function HookFormTimePicker({
  control,
  name,
  isRequired = false,
  ...props
}: Props) {
  return (
    <Controller
      control={control}
      name={name}
      rules={{ required: isRequired }}
      render={({ field: { onChange, value } }) => (
        <TimePicker {...props} value={value} onChange={onChange} />
      )}
    />
  );
}

export default HookFormTimePicker;
